import { Directive, Input } from '@angular/core';

import { AcceptedFileTypesService } from './accepted-file-types.service';
import type { FileTypesCategory } from './accepted-file-types.types';

@Directive({
  selector: '[rtAcceptedFileTypes]',
  standalone: true,
  host: {
    '[accept]': 'helperService.byCategoryAsString[category]',
  },
})
export class AcceptedFileTypesDirective {
  @Input('rtAcceptedFileTypes')
  public category: FileTypesCategory;

  constructor(public helperService: AcceptedFileTypesService) {}
}
